import { render, staticRenderFns } from "./DeleteCondoModal.vue?vue&type=template&id=5732ec10&"
import script from "./DeleteCondoModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCondoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5732ec10')) {
      api.createRecord('5732ec10', component.options)
    } else {
      api.reload('5732ec10', component.options)
    }
    module.hot.accept("./DeleteCondoModal.vue?vue&type=template&id=5732ec10&", function () {
      api.rerender('5732ec10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/DeleteCondoModal.vue"
export default component.exports